import React from 'react';

import { OneTimePasswordForm } from '../auth';

const ConfirmSignUpPage = () => {
  return <OneTimePasswordForm isConfirmSignUp={true} />;
};

export default ConfirmSignUpPage;
